




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import Dialog1 from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box6/dialog-1.vue';
import Dialog2 from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box6/dialog-2.vue';
import Dialog3 from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box6/dialog-3.vue';
@Component({
  components: { Dialog1, Dialog2, Dialog3 },
})
export default class Box1 extends Vue {
  private $echarts: any;
  private deptId: any = '';
  private dataForm: any = {};
  private topDataNumObj: any = {
    check: 0,
    hazard: 0,
    rectify: 0,
  };
  mounted() {
    this.getCountAllData({});
  }
  getCountAllData(opts: any) {
    const userInfo: any = localStorage.getItem('userInfo');
    const info: any = JSON.parse(userInfo);
    this.deptId = opts.deptId || info.deptId;
    zyScreenServer
      .getSecurityCheckCountData({
        inspectedUnitId: this.deptId,
      })
      .then((res: any) => {
        this.topDataNumObj = res.data;
      })
      .catch((e: any) => {
        console.log(e);
      });
    const map: any = {
      day: 'CURRENT_DAY',
      week: 'CURRENT_WEEK',
      month: 'CURRENT_MONTH',
      year: 'CURRENT_YEAR',
    };
    zyScreenServer
      .getCheckDayDistributed({
        dateRangeType: 'CURRENT_MONTH',
        selectDeptIds: this.deptId,
      })
      .then((res: any) => {
        this.dataForm = res.data;
        this.showCharts();
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  private showCharts() {
    const nameArr: any = [];
    const valueArr2: any = [];
    this.dataForm['安全检查'].forEach((item: any) => {
      valueArr2.push(item.yaxis); // 发现隐患
    });

    // const dataZoomMap: any = {
    //   day: [0, 100],
    //   week: [0, 100],
    //   month: [0, 20],
    // };

    const echartsA = this.$echarts.init(document.getElementById('charts-6') as any);
    const optionA = {
      title: {
        text: '',
        subtext: '',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      // legend: {
      //   data: ['监督检查'],
      //   x: 'right',
      //   y: 'top',
      //   textStyle: {
      //     fontSize: 10, //字体大小
      //     color: '#999', //字体颜色
      //   },
      //   itemWidth: 10, // 设置宽度
      //   itemHeight: 10, // 设置高度
      //   itemGap: 10, // 设置间距
      // },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '15%',
        top: '5%',
        containLabel: true,
      },
      yAxis: {
        type: 'value',
        // minInterval: 1,
        // name: '',
        axisLabel: {
          textStyle: {
            color: '#666',
            fontSize: 11,
          },
        },
        splitLine: {
          lineStyle: {
            color: '#666',
            type: 'dashed',
          },
        },
        boundaryGap: [0, 0.01],
        axisLine: {
          //y轴
          show: true,
          lineStyle: {
            color: '#666',
            type: 'dashed',
          },
        },
        axisTick: {
          //y轴刻度线
          show: false,
        },
        max: 10,
        min: 0,
      },
      xAxis: {
        // triggerEvent: true,
        data: nameArr,
        axisLine: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            color: '#888',
            fontSize: 10,
          },
        },
        boundaryGap: false,
      },
      series: [
        {
          name: '监督检查',
          type: 'line',
          data: valueArr2,
          color: '#00EAB8',
          smooth: true,
          itemStyle: {
            normal: {
              // barBorderRadius: barBorderRadius,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
      ],
    };
    echartsA.setOption(optionA);
  }

  showDialog1() {
    const refName = 'Dialog1Ref';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog({ deptId: this.deptId });
  }
  showDialog2() {
    const refName = 'Dialog2Ref';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog({ deptId: this.deptId });
  }
  showDialog3() {
    const refName = 'Dialog3Ref';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog({ deptId: this.deptId });
  }
}
